module.exports = __webpack_public_path__ + "static/media/denglu-2.8ee0bbeb.jpg";